/* eslint-disable import/no-anonymous-default-export */
import CatalogAPI from '../utils/NewCatalogAPI';

export default {
  async saveTracking(location, guid, email, detail) {
    if (email==null)
      email="na";

    if (detail==null)
      detail="";

    return CatalogAPI.post('/tracking/saveTracking', {
        siteLocation: location,
        userGuid: guid,
        emailAddress: email,
        detail: detail
    })
  },

  async saveSearch(guid, searchString, searchResult) {
    return CatalogAPI.post('/tracking/saveSearch', {
        userGuid: guid,
        searchString: searchString,
        searchResult: searchResult
    })
  }
};
